import {
	buildSerpMonitoringXlsx,
	findSerpMonitoringByProductAndMarket,
	updateSerpMonitoringResultCategory,
} from '@/API/repositories/serpMonitoring';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';
import { SERP_MONITORING_XLSX_FILENAME } from '../constants/files';
import { SERP_MONITORING_ERROR_MESSAGE } from '@/common/constants/serpMonitoring';

const useSerpMonitoringReport = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const [report, setReport] = useState();
	const [query, setQuery] = useState();
	const [pendingCategory, setPendingCategory] = useState();

	const isLoading =
		hasUnfilledRequest(findSerpMonitoringByProductAndMarket) ||
		hasUnfilledRequest(updateSerpMonitoringResultCategory) ||
		hasUnfilledRequest(buildSerpMonitoringXlsx);

	const fetchReport = async (payload) => {
		const response = await makeRequest(
			findSerpMonitoringByProductAndMarket.bind(null, payload),
		);

		if (!response?.data) {
			addMessage(SERP_MONITORING_ERROR_MESSAGE, 'error');
			return;
		}

		setQuery(payload);
		setReport(response.data);
	};

	const confirmCategoryChange = async () => {
		const canConfirmCategory = pendingCategory && query;

		if (!canConfirmCategory) {
			return;
		}

		const response = await makeRequest(
			updateSerpMonitoringResultCategory.bind(null, {
				resultId: pendingCategory.resultId,
				index: pendingCategory.index,
				category: pendingCategory.category,
			}),
		);

		if (!response?.data) {
			addMessage(SERP_MONITORING_ERROR_MESSAGE, 'error');
			return;
		}

		setPendingCategory(null);
		await fetchReport(query);
	};

	const buildXlsx = async () => {
		const response = await makeRequest(
			buildSerpMonitoringXlsx.bind(null),
		);

		if (!response?.data) {
			addMessage(SERP_MONITORING_ERROR_MESSAGE, 'error');
			return;
		}

		const fileUrl = window.URL.createObjectURL(response.data);
		const link = document.createElement('a');
		link.href = fileUrl;
		link.download = SERP_MONITORING_XLSX_FILENAME;
		link.click();
		window.URL.revokeObjectURL(fileUrl);
	};

	return {
		report,
		isLoading,
		pendingCategory,
		setPendingCategory,
		fetchReport,
		confirmCategoryChange,
		buildXlsx,
	};
};

export default useSerpMonitoringReport;
